export function trigger() {
  document.querySelectorAll('.trigger').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const body = document.body;
      const isActive = body.classList.contains('is-nav-active') ||
                       body.classList.contains('is-drawer-filter-active') ||
                       body.classList.contains('is-drawer-active');

      if (isActive) {
        body.classList.remove('is-nav-active', 'is-drawer-filter-active', 'is-drawer-active');
      } else {
        const target = el.dataset.trigger;
        if (target === 'nav') {
          body.classList.add('is-nav-active');
        } else if (target === 'filter') {
          body.classList.add('is-drawer-filter-active');
        }
      }
    });
  });
  
  const triggerReset = document.querySelectorAll('.trigger-reset');
  if(triggerReset.length) {
    triggerReset.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.remove('is-nav-active', 'is-drawer-filter-active', 'is-drawer-active');
      });
    })
  }
}
